import {
    Box,
    Button,
    Grid,
    IconButton,
    makeStyles,
    TextField,
    Typography,
} from "@material-ui/core";
import {
    ToggleButton,
    ToggleButtonGroup
} from "@material-ui/lab";
import React from "react";
import {Controller, useForm} from "react-hook-form";
import {useLoading} from "../../../../util/LoadingProvider";
import {DatePicker} from "@material-ui/pickers";
import TableContainer
    from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import MenuItem from "@material-ui/core/MenuItem";
import {
    useGlobalFilter,
    usePagination,
    useRowSelect,
    useTable
} from "react-table";
import {Edit} from "@material-ui/icons";
import {Link} from "react-router-dom";
import {openLinkWithState} from "../../../../util";
import apiHelper from "../../../../util/ApiHelper";
import {toast} from "react-toastify";
import {
    PaginationHandler
} from "../../../../util/useManualPagination";
import {useHistory} from "react-router";
import * as Yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import PaginationBarForHandler from "../../../common/PaginationBarForHandler";

const useStyles = makeStyles((theme) => ({
    innerBox: {
        background: "#ffffff",
        marginBottom: theme.spacing(4),
        "& *": {
            fontSize: "13px",
            lineHeight: "15px",
        },
    },
    sectionBox: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
    },
    sectionTitle: {
        fontWeight: "300",
        fontSize: "13px",
        lineHeight: "15px",
        color: "#333333",
    },
    itemTitle: {
        fontWeight: "bold",
        fontSize: "12px",
        lineHeight: "14px",
        color: "#333333",
    },
    itemValue: {
        fontWeight: "normal",
        fontSize: "14px",
        lineHeight: "16px",
        color: "#333333",
    },
    input: {
        width: "100%",
        "& button": {
            fontSize: "13px",
            lineHeight: "15px",
            width: "25%",
            color: "grey !important"
        },
    },
    buttonGroup: {
        textAlign: "right",
        marginTop: "-20px",
        "& button": {
            color: "#306F9D",
            fontSize: "13px",
            textTransform: "inherit",
        },
    },
    customLabel: {
        "& label": {
            color: "black",
            fontWeight: 700,
            fontSize: "16px",
        },
    },
    select: {
        "& .MuiSelect-icon": {
            top: "calc(50% - 6px)"
        }
    },
    pagination: {
        "& .MuiTextField-root": {
            width: "35px",
            minWidth: "auto",
        },
        "& .MuiSelect-root": {
            paddingTop: "3px",
            paddingBottom: "3px",
        },
        "& input": {
            padding: "4px 0",
            marginLeft: "10px",
            marginRight: "10px",
        },
        "& button": {
            background: "white",
            color: "#cccccc",
            border: "1px solid #CCCCCC",
            minWidth: "auto",
            width: "24px",
            height: "24px",
            margin: "4px 0",
            "&.left": {
                borderRadius: "4px 0 0 4px",
                marginLeft: "10px",
            },
            "&.right": {
                borderRadius: " 0 4px 4px 0",
            },
        },
    },
    text: {
        textDecoration: "none",
        color: "#306F9D",
    },
}));

const defaultFormValues = {
    firstName: "",
    lastName: "",
    email: "",
    contactNumber: "",
    address: "",
    dob: "",
    isExistingMember: false
};

function MemberDetailPage(props) {
    const classes = useStyles();
    const history = useHistory();
    const {match, disabled} = props;
    const {id} = match.params;
    const urlFragments = match.url.split('/');
    const url = urlFragments.slice(0, urlFragments.length - 1).join('/');
    const [defaultValue, setDefaultValue] = React.useState(defaultFormValues);
    const [data, setData] = React.useState([]);
    const [totalPages, setTotalPages] = React.useState(1);
    const {setLoading} = useLoading();
    // for pagination
    const [paginationHandler] = React.useState(new PaginationHandler());
    const [elementCounts, setElementCounts] = React.useState(0);

    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required("Required"),
        lastName: Yup.string().required("Required"),
        email: Yup.string().required("Required").email("Please enter a valid email."),
        contactNumber: Yup.string().required("Required")
    });

    const CustomLink = React.useMemo(
        () =>
            React.forwardRef((linkProps, ref) => <Link
                ref={ref} {...linkProps} />),
        []
    );

    {/* no DELETE method for membership records yet */
    }
    // const deleteMemberRecord = async (id) => {
    //     const decision = await modal.fire({
    //         title: "Delete Member Record",
    //         text: "Are you sure to delete this Member Record?",
    //         showCancelButton: true,
    //         confirmButtonText: `Delete`,
    //     });
    //     if (decision.isConfirmed) {
    //         try {
    //             const result = await apiHelper.hkiff.deleteMemberRecordById(id);
    //             if (result.data.code === 0) {
    //                 toast.dark("Member Record deleted.");
    //                 await getMemberById();
    //             }
    //         } catch (err) {
    //             console.log(err);
    //         }
    //     }
    // };

    const {
        control,
        handleSubmit,
        reset,
    } = useForm({
        defaultValues: React.useMemo(() => defaultValue, [defaultValue]),
        resolver: yupResolver(validationSchema),
    });

    const columns = React.useMemo(
        () => [
            {
                Header: "Plan Name",
                accessor: "planName",
                Cell: ({row}) => {
                    return (
                        <Link
                            to={`${url}/record/${row.original.id}`}
                            className={classes.text}
                            onClick={(event) => {
                                openLinkWithState(history, `${url}/record/${row.original.id}`, {
                                    ...row.original,
                                    isExistingMember: !!defaultValue?.isExistingMember
                                }, event);
                            }}
                        >
                            {row.original.plan?.localizations?.en?.name || '-'}
                            {row.original.orderType && ' ('+row.original.orderType+')'}
                        </Link>
                    );
                },
            },
            {
                Header: "Valid From",
                accessor: "validFrom",
                disableGlobalFilter: true,
                Cell: ({row}) => {
                    return row.original.validFrom
                },
            },
            {
                Header: "Valid To",
                accessor: "expiryDate",
                disableGlobalFilter: true,
                Cell: ({row}) => {
                    return row.original.expiryDate;
                },
            },
            {
                Header: "Total Amount",
                accessor: "totalAmount",
                disableGlobalFilter: true,
                Cell: ({row}) => {
                    return row.original.totalAmount;
                },
            },
            {
                Header: "Status",
                accessor: "status",
                disableGlobalFilter: true,
                Cell: ({row}) => {
                    switch (row.original.plan?.status) {
                        case "ACTIVE":
                            return <span
                                className={classes.text}>Active</span>
                        default:
                        case "INACTIVE":
                            return <span
                                className={classes.text}>Inactive</span>
                    }
                },
            },
            {
                id: "action",
                // The header can use the table's getToggleAllRowsSelectedProps method
                // to render a checkbox
                Header: () => <div>Action</div>,
                // The cell can use the individual row's getToggleRowSelectedProps method
                // to the render a checkbox
                Cell: ({row}) => (
                    <div
                        style={{display: "inline-flex"}}>
                        <IconButton
                            className={classes.iconBtn}
                            size="small"
                            component={CustomLink}
                            to={`${url}/record/${row.original.id}`}
                            onClick={(event) => {
                                openLinkWithState(history, `${url}/record/${row.original.id}`, {
                                    ...row.original,
                                    isExistingMember: !!defaultValue?.isExistingMember
                                }, event);
                            }}
                        >
                            <Edit fontSize="small"/>
                        </IconButton>
                        {/* no DELETE method for membership records yet */}
                        {/*{!disabled && (*/}
                        {/*    <IconButton*/}
                        {/*        className={classes.iconBtn}*/}
                        {/*        size="small"*/}
                        {/*        onClick={() => {*/}
                        {/*            deleteMemberRecord(row.original.id);*/}
                        {/*        }}*/}
                        {/*    >*/}
                        {/*        <Delete*/}
                        {/*            fontSize="inherit"/>*/}
                        {/*    </IconButton>*/}
                        {/*)}*/}
                    </div>
                ),
            },
        ],
        [classes.text, defaultValue?.isExistingMember, history, url]
    );

    const {
        getTableProps,
        headerGroups,
        rows,
        prepareRow,
        setPageSize,
        gotoPage,
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
        state: {pageIndex, pageSize},
    } = useTable(
        {
            columns,
            data,
            initialState: {pageIndex: 0, pageSize: 10},
            manualPagination: true,
            pageCount: totalPages,
        },
        useGlobalFilter,
        usePagination,
        useRowSelect
    );

    const onSubmit = async (value) => {
        setLoading(true);
        try {
            const {status, ...req} = value;
            req.status = status;
            const res = await apiHelper.hkiff.updateMemberById(id, req);
            if (res.status === 200) {
                toast.dark("Member is updated.");
            }
        } catch (e) {
            console.log(e);
        }
        setLoading(false);
    };

    const getMemberById = React.useCallback(async () => {
        try {
            setLoading(true);
            const results = await apiHelper.hkiff.getMemberById(id);
            console.log(results);
            if (results.status === 200) {
                const {
                    orders,
                    createDate,
                    id,
                    ...memberDetail
                } = results.data;
                console.log('memberDetail', memberDetail);
                setDefaultValue(memberDetail);
                reset(memberDetail);
                paginationHandler.setPageIndex(0).setRows(orders);
                const content = paginationHandler.filterRowsByAll().getRows();
                const totalPages = paginationHandler.getTotalPages();
                setData(content.filter((x) => x));
                const all = paginationHandler.getStatuslessRows().length;
                setElementCounts(all);
                setTotalPages(totalPages);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }, [setLoading]);

    React.useEffect(() => {
        if (paginationHandler) getMemberById();
    }, [getMemberById, paginationHandler]);


    console.log(defaultValue);

    return (
        <Box>
            <Typography variant="h4" gutterBottom>
                Membership &gt; Member Detail
            </Typography>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Box className={classes.innerBox}>
                    <Box className={classes.sectionBox}>
                        <Grid container xs={12}
                              direction="row" spacing={3}>
                            <Grid item xs={12}>
                                <strong>User Info</strong>
                            </Grid>
                        </Grid>
                        <Grid container xs={12}
                              direction="row" spacing={3}>
                            <Grid item xs={12}>
                                <strong>Status</strong>
                            </Grid>
                        </Grid>
                        <Grid container xs={12}
                              direction="row" spacing={3}>
                            <Grid container item
                                  direction="column"
                                  spacing={1} xs={6}>
                                <Grid item>
                                    <Controller
                                        control={control}
                                        name="status"
                                        render={({
                                                     field: {
                                                         value,
                                                         onChange,
                                                         ...rest
                                                     },
                                                 }) => (
                                            <ToggleButtonGroup
                                                {...rest}
                                                value={value}
                                                exclusive
                                                aria-label="Status"
                                                className={classes.input}
                                            >
                                                <ToggleButton
                                                    value={true}
                                                    disabled={true}
                                                    aria-label="Active">
                                                    Active
                                                </ToggleButton>
                                                <ToggleButton
                                                    value={false}
                                                    disabled={true}
                                                    aria-label="Expired">
                                                    Inactive
                                                </ToggleButton>
                                            </ToggleButtonGroup>
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box className={classes.sectionBox}>
                        <Grid container item xs={12}
                              spacing={3}>
                            <Grid item xs={6}>
                                <Controller
                                    name="firstName"
                                    control={control}
                                    render={({
                                                 field,
                                                 fieldState: {error}
                                             }) => (
                                        <TextField
                                            label="First Name"
                                            variant="outlined"
                                            margin="dense"
                                            className={classes.textInput}
                                            fullWidth
                                            {...field}
                                            error={!!error}
                                            helperText={error ? error.message : ""}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Controller
                                    name="lastName"
                                    control={control}
                                    render={({
                                                 field,
                                                 fieldState: {error}
                                             }) => (
                                        <TextField
                                            label="Last Name"
                                            variant="outlined"
                                            margin="dense"
                                            className={classes.textInput}
                                            fullWidth
                                            {...field}
                                            error={!!error}
                                            helperText={error ? error.message : ""}
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>
                        <Grid container item xs={12}
                              spacing={3}>
                            <Grid item xs={6}>
                                <Controller
                                    name="email"
                                    control={control}
                                    render={({
                                                 field,
                                                 fieldState: {error}
                                             }) => (
                                        <TextField
                                            label="Email"
                                            variant="outlined"
                                            margin="dense"
                                            className={classes.textInput}
                                            fullWidth
                                            {...field}
                                            error={!!error}
                                            helperText={error ? error.message : ""}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <Controller
                                    name="contactNumber"
                                    control={control}
                                    render={({
                                                 field,
                                                 fieldState: {error}
                                             }) => (
                                        <TextField
                                            label="Contact No."
                                            variant="outlined"
                                            margin="dense"
                                            className={classes.textInput}
                                            fullWidth
                                            {...field}
                                            error={!!error}
                                            helperText={error ? error.message : ""}
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>
                        <Grid container item xs={12}
                              spacing={3}>

                            <Grid item xs={6}>
                                <Controller
                                    name="address"
                                    control={control}
                                    render={({
                                                 field,
                                                 fieldState: {error}
                                             }) => (
                                        <TextField
                                            label="Address"
                                            variant="outlined"
                                            margin="dense"
                                            className={classes.textInput}
                                            fullWidth
                                            {...field}
                                            error={!!error}
                                            helperText={error ? error.message : ""}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Controller
                                    name="dob"
                                    control={control}
                                    render={({
                                                 field,
                                                 fieldState: {error}
                                             }) => (
                                        <DatePicker
                                            fullWidth
                                            variant="outlined"
                                            inputVariant="outlined"
                                            openTo="year"
                                            margin="dense"
                                            views={["year", "month"]}
                                            label="Date of Birth"
                                            className={classes.textInput}
                                            {...field}
                                            error={!!error}
                                            helperText={error ? error.message : ""}
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Box>

                <div className={classes.buttonGroup}>
                    <Button
                        type="submit"
                        variant="contained"
                        disableElevation
                        style={{
                            color: "white",
                            background: "#306F9D",
                            padding: "9px 16px",
                        }}
                    >
                        Save Changes
                    </Button>
                </div>

                <Box fontWeight={900} fontSize={13} mt={4}
                     mb={2} width="100%">
                    <Typography variant="p">
                        Membership Record
                    </Typography>
                </Box>

                <Grid container xs={12}>
                    <TableContainer
                        component={Paper}
                        style={{
                            boxShadow: "none",
                            border: "1px solid #cccccc",
                        }}
                    >
                        <fieldset disabled={disabled}
                                  className="fieldset">
                            <Table
                                aria-label="simple table"
                                component="ul"
                                style={{margin: "0"}}
                                {...getTableProps()}
                            >
                                <colgroup>
                                    <col
                                        style={{width: "30%"}}/>
                                    <col
                                        style={{width: "20%"}}/>
                                    <col
                                        style={{width: "20%"}}/>
                                    <col
                                        style={{width: "15%"}}/>
                                    <col
                                        style={{width: "10%"}}/>
                                    <col
                                        style={{width: "5%"}}/>
                                </colgroup>
                                <TableHead component="div">
                                    {headerGroups.map((headerGroup) => (
                                        <TableRow {...headerGroup.getHeaderGroupProps()}>
                                            {headerGroup.headers.map((column) => (
                                                <TableCell
                                                    {...column.getHeaderProps()}
                                                    className={`${column.className ?? ""}`}
                                                    style={{
                                                        paddingTop: 6,
                                                        paddingBottom: 6,
                                                        lineHeight: "1.1em",
                                                        height: "48px",
                                                    }}
                                                >
                                                    {column.render("Header")}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableHead>
                                <TableBody>
                                    {rows.map((row) => {
                                        prepareRow(row);
                                        return (
                                            <TableRow {...row.getRowProps()}>
                                                {row.cells.map((cell) => {
                                                    return (
                                                        <TableCell
                                                            {...cell.getCellProps()}
                                                            className={`${cell.column.className ?? ""}`}
                                                            style={{
                                                                paddingTop: 6,
                                                                paddingBottom: 6,
                                                                lineHeight: "1.1em",
                                                                height: "48px",
                                                            }}
                                                        >
                                                            {cell.render("Cell")}
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </fieldset>
                    </TableContainer>
                </Grid>
                <Grid
                    container
                    justify="flex-end"
                    style={{
                        paddingRight: "25px",
                        marginTop: "15px"
                    }}
                >
                    <div className={classes.flexRow}>
                        <PaginationBarForHandler
                            pageSize={pageSize}
                            setPageSize={setPageSize}
                            setData={setData}
                            setTotalPages={setTotalPages}
                            paginationHandler={paginationHandler}
                            gotoPage={gotoPage}
                            pageIndex={pageIndex}
                            canPreviousPage={canPreviousPage}
                            previousPage={previousPage}
                            nextPage={nextPage}
                            canNextPage={canNextPage}
                            elementCounts={{ all: elementCounts, active: 0, inactive: 0,}}
                            status={'all'}
                        />
                    </div>
                </Grid>
            </form>
        </Box>
    );
}

export default MemberDetailPage;
